import {h} from 'preact'
import {useContext, useEffect, useState} from "preact/hooks";

import SalonCard from "../blocks/SalonCard";
import {route} from "preact-router";

import {getPopularStylists} from "../../data-providers/common-data-provicer";
import {HomeContext} from "../../context/HomeContext";

export default () => {
    const [recommended, setRecommended] = useState([])
    const context = useContext(HomeContext);

    const openSalon = (id) => {
        route(`/stylists/${id}`)
    }

    useEffect(() => {
        let countryName = context.city.name === 'Accra' ? 'Ghana' : 'Lagos'
        getPopularStylists(20, countryName).then(res => {
            setRecommended(res.data)
        })
    }, [])

    return (
        <section className="recommended-stylist">
            <div className="content">
                <div className="heading">
                    <h2>More stylists</h2>
                    <p>We have found other beauticians you may like</p>
                </div>
                <div className="result-list">
                    {recommended.map(el => {
                        return (
                            <SalonCard key={`salon-card-${el.username}`} {...el} onClickExplore={openSalon}/>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}